import { RouteConfig } from 'vue-router'

const dashboard = () => import('@/nms/pages/dashboard/dashboard.vue')
const configuration = () => import('@/nms/pages/configuration/configuration.vue')
const reports = () => import('@/nms/pages/reports/reports.vue')

const routes: RouteConfig[] = [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      keepAlive: true,
    },
    component: dashboard,
    props: {
      tags: 'main',
    },
  },
  {
    path: '/settings',
    name: 'settings',
    meta: {},
    component: configuration,
  },
  {
    path: '/reports',
    name: 'reports',
    meta: {},
    component: reports,
  },
]

export default routes